import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import Swiper, { EffectCards } from 'swiper';
import { t } from '../../theme/locales';
export const WishlistCover = ({ wishlist , handleViewList  })=>{
    const swiperContainerRef = useRef(null);
    const swiperRef = useRef(null);
    const [isSwiperReady, setIsSwiperReady] = useState(false);
    useEffect(()=>{
        var _swiperRef_current;
        if (!swiperContainerRef.current) {
            return;
        }
        Swiper.use([
            EffectCards
        ]);
        setIsSwiperReady(false);
        (_swiperRef_current = swiperRef.current) === null || _swiperRef_current === void 0 ? void 0 : _swiperRef_current.destroy(true, true);
        swiperRef.current = new Swiper(swiperContainerRef.current, {
            init: false,
            effect: 'cards',
            slidesPerView: 1,
            grabCursor: true,
            slideToClickedSlide: true,
            fadeEffect: {
                crossFade: true
            },
            on: {
                afterInit: ()=>{
                    setIsSwiperReady(true);
                }
            }
        });
        swiperRef.current.init();
        return ()=>{
            var _swiperRef_current;
            (_swiperRef_current = swiperRef.current) === null || _swiperRef_current === void 0 ? void 0 : _swiperRef_current.destroy(true, true);
            swiperRef.current = null;
            setIsSwiperReady(false);
        };
    }, [
        wishlist.lid,
        wishlist.listcontents.length
    ]);
    const isEmptyWishlist = wishlist.listcontents.length === 0;
    const images = wishlist.listcontents.map((item)=>{
        var _entry_cprops, _entry_cprops_images, _entry_cprops1, _entry_cprops_images1;
        const entry = item;
        return ((_entry_cprops = entry.cprops) === null || _entry_cprops === void 0 ? void 0 : (_entry_cprops_images = _entry_cprops.images) === null || _entry_cprops_images === void 0 ? void 0 : _entry_cprops_images[1]) || ((_entry_cprops1 = entry.cprops) === null || _entry_cprops1 === void 0 ? void 0 : (_entry_cprops_images1 = _entry_cprops1.images) === null || _entry_cprops_images1 === void 0 ? void 0 : _entry_cprops_images1[0]) || item.iu;
    }).filter((src)=>typeof src === 'string' && src.length > 0).slice(0, 3);
    const slots = [
        0,
        1,
        2
    ];
    return h('article', {
        className: 'wishlist-page__cover',
        role: 'button',
        tabindex: '0',
        'aria-label': wishlist.lname,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                handleViewList(wishlist);
            }
        },
        onClick: ()=>handleViewList(wishlist)
    }, [
        h('div', {
            className: 'wishlist-page__cover-inner'
        }, [
            h('div', {
                className: `wishlist-page__cover-media swiper${isSwiperReady ? ' is-ready' : ''}`,
                ref: swiperContainerRef
            }, h('div', {
                className: 'wishlist-page__cover-media-wrapper swiper-wrapper'
            }, slots.map((slot)=>{
                const src = images[slot];
                if (isEmptyWishlist && slot === 0) {
                    return h('div', {
                        className: `wishlist-page__cover-layer swiper-slide wishlist-page__cover-layer--${slot + 1}`,
                        key: `${wishlist.lid}-${slot}`
                    }, h('div', {
                        className: 'wishlist-page__cover-empty'
                    }, [
                        h('p', {
                            className: 'wishlist-page__cover-empty-title'
                        }, t('wishlist.start_new_list')),
                        h('p', {
                            className: 'wishlist-page__cover-empty-text'
                        }, t('wishlist.start_new_list_text'))
                    ]));
                }
                return h('figure', {
                    className: `wishlist-page__cover-layer swiper-slide wishlist-page__cover-layer--${slot + 1}`,
                    key: `${wishlist.lid}-${slot}`
                }, src ? h('img', {
                    className: 'wishlist-page__cover-image',
                    src,
                    alt: t('wishlist.cover_image_alt').replace('{{ name }}', wishlist.lname).replace('{{ index }}', String(slot + 1))
                }) : h('div', {
                    className: 'wishlist-page__cover-image wishlist-page__cover-image--fallback',
                    'aria-hidden': 'true'
                }));
            }))),
            h('div', {
                className: 'wishlist-page__cover-footer'
            }, [
                h('p', {
                    className: 'wishlist-page__cover-title'
                }, [
                    wishlist.lname,
                    h('span', {
                        className: 'wishlist-page__cover-meta'
                    }, ` ♥ ${wishlist.listcontents.length}`)
                ]),
                h('button', {
                    type: 'button',
                    className: 'wishlist-page__cover-link',
                    'aria-label': t('wishlist.view_list_aria').replace('{{ name }}', wishlist.lname)
                }, t('wishlist.view_list'))
            ])
        ])
    ]);
};
